import { IPatientSurvey } from "../../types/types"

interface ISurveyListCard {
  patientSurvey: IPatientSurvey
  openSurvey: () => void
}

const surveyNames = {
  professional_lifestyle: "Mode de vie Professionel",
  personal_lifestyle: "Mode de vie personnel",
  medical_history: "Histoire de santé",
  medical_information: "Informations médicales",
  imaging_report: "Compte rendu d'imagerie",
  life_quality: "Qualité de vie",
  filter_pain_walk_scale: "Échelles de douleurs et de marche",
  pain_management: "Gestion de la douleur",
  back_to_normal: "Retour à la vie active",
  satisfaction: "Satisfaction de l'app",
  drug_consumption: "Consommation médicamenteuse",
  filter_medical_information: "Histoire de santé",
  filter_personal_informations: "Informations Personnelles",
  filter_consultation_infos: "Informations de Consultation",
  filter_phase_2_consultation_infos: "Informations de Consultation",
  filter_phase_2_medical_information: "Histoire de santé",
  filter_cervical_pain_neck_scale: "Échelles de douleurs",
  filter_cervical_medical_information: "Histoire de santé",
  neck_disability_index: "Qualité de vie",
  appointement_recommandation: "Recommandation"
}

const SurveyListCard = (props: ISurveyListCard) => {
  return (
    <div className="flex flex-col w-80 md:w-96 rounded-xl px-4 py-4 bg-cortexx-50 border-slate-300 border">
      <div className="font-bold text-cortexx-550">
        {
          surveyNames[
            props.patientSurvey.survey_reference as keyof typeof surveyNames
          ]
        }
      </div>
      <div className="font-normal text-slate-500">
        Répondu le{" "}
        {new Date(props.patientSurvey.submission.created_at).toLocaleDateString(
          "fr"
        )}
      </div>
      <div className="flex justify-end">
        <button className="flex" onClick={() => props.openSurvey()}>
          <div className="bg-cortexx-550 rounded-lg mt-2 text-center justify-center px-8 py-2">
            <div className="text-cortexx-50">Voir</div>
          </div>
        </button>
      </div>
    </div>
  )
}

export default SurveyListCard
